var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"256","height":"256"}})}
var staticRenderFns = []

export { render, staticRenderFns }